import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=d2e1cc8c&scoped=true"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=d2e1cc8c&prod&lang=scss&scoped=true"
import style1 from "./Notes.vue?vue&type=style&index=1&id=d2e1cc8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e1cc8c",
  null
  
)

export default component.exports